import React, {  useRef,useEffect, useState,useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import IconButton from '@mui/material/IconButton'; 
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem  from "@mui/material/MenuItem";
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import ContractSearchStores from "pages/contracts/editOrNewContract/ContractSearchStores"; 
import ContractSearchStoresAddresses from "pages/contracts/editOrNewContract/ContractSearchStoresAddress";
import ContractSearchStoresNimaAddresses from "pages/contracts/editOrNewContract/ContractSearchStoresNimaAddress";
import PropTypes from 'prop-types';

const initialPostalCodesToSelect = [{
    "id":0,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":0
}];

const initialDocumentIdToSelect = [{
    "id": 0,
    "documentid": "",
    "tradename": ""
}];

const initialNimaToSelect = [{
    "id":0,
    "nima":""
}];

const ContractCreateOrEditAutDest = ({formContract,setFormContract,setIsLoadingErrorData,errorsForm,setErrorsForm,validateFormContract,documentTypesToSelect,roadTypesToSelect,communityToSelect,expanded,optTypeToSelect}) => {
    const {t,i18n} = useTranslation(['listDataContracts']);
    const token = useSelector((state) => state.loginUser.token); 
    const roles = useSelector((state) => state.loginUser.roles);  
    const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
    const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
    const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
    const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
    const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
    const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
    const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
    const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
    const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
    const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
    const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 
    const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
    const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false); 
    const [showModalSearchStoresNimaAddress, setShowModalSearchStoresNimaAddress] = useState(false);          
    const dispatch = useDispatch(); 
    
    const [postalCodeAutDestToSelect,setPostalCodeAutDestToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeAutDest, setFilteredpostalCodeAutDest] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeAutDest, setHighlightedIndexPostalCodeAutDest] = useState(-1); // Índice de la opción resaltada 
    const [documentIdAutDestToSelect,setDocumentIdAutDestToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredDocumentIdAutDest, setFilteredDocumentIdAutDest] = useState([]); // Opciones filtradas
    const [highlightedIndexDocumentIdAutDest, setHighlightedIndexDocumentIdAutDest] = useState(-1); // Índice de la opción resaltada 
    const [tradenameAutDestToSelect,setTradenameAutDestToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredTradenamedAutDest, setFilteredTradenamedAutDest] = useState([]); // Opciones filtradas
    const [highlightedIndexTradenamedAutDest, setHighlightedIndexTradenamedAutDest] = useState(-1); // Índice de la opción resaltada 
    const [autDestNimaToSelect,setAutDestNimaToSelect]= useState(initialNimaToSelect);  
    const [filteredAutDestNima, setFilteredAutDestNima] = useState([]); // Opciones filtradas
    const [highlightedIndexAutDestNima, setHighlightedIndexAutDestNima] = useState(-1); // Índice de la opción resaltada 

    const ddRefDocIdAutDest = useRef(null);
    const ddRefTradeAutDest = useRef(null);
    const ddRefNimaAutDest = useRef(null);
    const ddRefPostalAutDest = useRef(null);

    // Debounce helper
    const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
    };
    
    // Dentro del componente
    const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeAutDest([]);
            setHighlightedIndexPostalCodeAutDest(-1);
        return;
        }
        const filtered = postalCodeAutDestToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeAutDest(filtered);
        setHighlightedIndexPostalCodeAutDest(0);
    }, 300); 

    const handleSelectPostalCodeAutDest = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
            ...formContract,
            aut_dest_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
            aut_dest_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            aut_dest_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
            aut_dest_province_id: postal.province_id || Number(DEFAULTPROVINCE)
        }));
        setFilteredpostalCodeAutDest([]);
        setHighlightedIndexPostalCodeAutDest(-1);
    }; 

    const handleKeyDownDPostalCodeAutDest = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeAutDest.length === 0 && formContract.aut_dest_postalcode_code.trim() === "") {
            setHighlightedIndexPostalCodeAutDest(postalCodeAutDestToSelect);
            setHighlightedIndexPostalCodeAutDest(0);
        } else {
            setHighlightedIndexPostalCodeAutDest((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeAutDest.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex,ddRefPostalAutDest);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexPostalCodeAutDest((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid,ddRefPostalAutDest);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeAutDest >= 0) {
            if (highlightedIndexPostalCodeAutDest >= 0 && highlightedIndexPostalCodeAutDest < filteredpostalCodeAutDest.length) {
                handleSelectPostalCodeAutDest(filteredpostalCodeAutDest[highlightedIndexPostalCodeAutDest]);
            }
        } else if (event.key === "Escape") {
            const isValid = postalCodeAutDestToSelect.some((postal) => {
                if (!postal || !postal.postalcode) return false; 
                const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.aut_dest_postalcode_code.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormContract((formContract) => ({
                ...formContract,
                aut_dest_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
                aut_dest_postalcode_code:  DEFAULTPOSTALCODE_CODE,
                aut_dest_postalcode_name: DEFAULTPOSTALCODE_NAME,
                aut_dest_province_id: Number(DEFAULTPROVINCE)
            }));
        } 
        setFilteredpostalCodeAutDest([]);
        setHighlightedIndexPostalCodeAutDest(-1);
        }
    };

    // Dentro del componente
    const debouncedHandleSearchDocumentId = useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDocumentIdAutDest([]);
            setHighlightedIndexDocumentIdAutDest(-1);
            return;
        }
        const filtered = documentIdAutDestToSelect
            .filter(store => store && store.documentid)
            .filter(store => {
            const documentid = store.documentid.toUpperCase();
            return documentid.includes(upperValue);
            })
            .slice(0, 20); // limitar resultados
        setFilteredDocumentIdAutDest(filtered);
        setHighlightedIndexDocumentIdAutDest(0);
    }, 300);
    const handleSelectDocumentIdOri = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
            ...formContract,
            aut_dest_documentid: store.documentid || "",
        }));
        setFilteredDocumentIdAutDest([]);
        setHighlightedIndexDocumentIdAutDest(-1);
    }; 
    const handleKeyDownDocumentIdAutDest = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredDocumentIdAutDest.length === 0 && formContract.aut_dest_documentid.trim() === "") {
            setFilteredDocumentIdAutDest(documentIdAutDestToSelect);
            setHighlightedIndexDocumentIdAutDest(0);
        } else {
            setHighlightedIndexDocumentIdAutDest((prevIndex) => {
            const nextIndex = prevIndex < filteredDocumentIdAutDest.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex,ddRefDocIdAutDest);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexDocumentIdAutDest((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid,ddRefDocIdAutDest);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdAutDest >= 0) {
        if (highlightedIndexDocumentIdAutDest >= 0 && highlightedIndexDocumentIdAutDest < filteredDocumentIdAutDest.length) {
            handleSelectDocumentIdOri(filteredDocumentIdAutDest[highlightedIndexDocumentIdAutDest]);
        }
        } else if (event.key === "Escape") {
            const isValid = documentIdAutDestToSelect.some((store) => {
                if (!store || !store.documentid) return false; 
                const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.aut_dest_documentid.toUpperCase();
                return normalizedStoreId === normalizedInputId;
            }); 
        if (!isValid) {
            setFormContract((formContract) => ({
            ...formContract,
            aut_dest_documentid: "",
            }));
        } 
        setFilteredDocumentIdAutDest([]);
        setHighlightedIndexDocumentIdAutDest(-1);
        }
    };

    // Dentro del componente
    const debouncedHandleSearchTradename= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredTradenamedAutDest([]);
            setHighlightedIndexTradenamedAutDest(-1);
        return;
        }
        const filtered = tradenameAutDestToSelect
        .filter(store => store && store.tradename)
        .filter(store => {
            const tradename = store.tradename.toUpperCase();
            return tradename.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredTradenamedAutDest(filtered);
        setHighlightedIndexTradenamedAutDest(0);
    }, 300); 

    const handleSelectTradeNameAutDest = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
        ...formContract,
        aut_dest_tradename: store.tradename || "",
        aut_dest_documentid: store.documentid || formContract.aut_dest_documentid,
        
        }));
        setFilteredTradenamedAutDest([]);
        setHighlightedIndexTradenamedAutDest(-1);
    }; 

    const handleKeyDownTradenameAutDest = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredTradenamedAutDest.length === 0 && formContract.aut_dest_tradename.trim() === "") {
            setFilteredTradenamedAutDest(tradenameAutDestToSelect);
            setHighlightedIndexTradenamedAutDest(0);
        } else {
            setHighlightedIndexTradenamedAutDest((prevIndex) => {
            const nextIndex = prevIndex < filteredTradenamedAutDest.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex,ddRefTradeAutDest);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexTradenamedAutDest((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid,ddRefTradeAutDest);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedAutDest >= 0) {
        if (highlightedIndexTradenamedAutDest >= 0 && highlightedIndexTradenamedAutDest < filteredTradenamedAutDest.length) {
            handleSelectTradeNameAutDest(filteredTradenamedAutDest[highlightedIndexTradenamedAutDest]);
        }
        } else if (event.key === "Escape") {
        const isValid = tradenameAutDestToSelect.some((store) => {
            if (!store || !store.tradename) return false; 
            const normalizedTradeName = store.tradename.toUpperCase();
            const normalizedInputTradeName = formContract.aut_dest_tradename.toUpperCase();
            return normalizedTradeName === normalizedInputTradeName;
        }); 
        if (!isValid) {
            setFormContract((formContract) => ({
            ...formContract,
            aut_dest_tradename: "",
            }));
        } 
        setFilteredTradenamedAutDest([]);
        setHighlightedIndexTradenamedAutDest(-1);
        }
    }; 

    // Dentro del componente
    const debouncedHandleSearchAutDestNima= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredAutDestNima([]);
            setHighlightedIndexAutDestNima(-1);
        return;
        }
        const filtered = autDestNimaToSelect
        .filter(nt => nt && nt.nima)
        .filter(nt => {
            const nima = nt.nima.toUpperCase();
            return nima.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredAutDestNima(filtered);
        setHighlightedIndexAutDestNima(0);
    }, 300); 
    const handleSelectAutDestNima = (nt) => {
        if (!nt) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
        ...formContract,
        aut_dest_nima: nt.nima || ""
        }));
        setFilteredAutDestNima([]);
        setHighlightedIndexAutDestNima(-1);
    }; 
    const handleKeyDownAutDestNima = (event) => {
       if (event.key === "ArrowDown") {
            if (filteredAutDestNima.length === 0 && formContract.aut_dest_nima.trim() === "") {
                const filtered = autDestNimaToSelect.filter(nt => nt && nt.nima).slice(0, 20);
                setFilteredAutDestNima(filtered);
                setHighlightedIndexAutDestNima(0);
            } else {
                setHighlightedIndexAutDestNima((prevIndex) => {
                    const nextIndex = prevIndex < filteredAutDestNima.length - 1 ? prevIndex + 1 : prevIndex;
                    scrollToElement(nextIndex,ddRefNimaAutDest);
                    return nextIndex;
                });
            }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexAutDestNima((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid,ddRefNimaAutDest);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexAutDestNima >= 0) {
            if (highlightedIndexAutDestNima >= 0 && highlightedIndexAutDestNima < filteredAutDestNima.length) {
                handleSelectAutDestNima(filteredAutDestNima[highlightedIndexAutDestNima]);
            }
        } else if (event.key === "Escape") {
            const isValid = autDestNimaToSelect.some((nt) => {
                if (!nt || !nt.nima) return false; 
                const normalizedPostalCodeId = nt.nima.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.aut_dest_nima.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormContract((formContract) => ({
                ...formContract, 
                aut_dest_nima: ""
            }));
        } 
        setFilteredAutDestNima([]);
        setHighlightedIndexAutDestNima(-1);
        }
    };

    // Función para desplazar el contenedor
    const scrollToElement = (index, ref) => {
        const dropdown = ref?.current;
        const item = dropdown?.children?.[index];
        if (item) item.scrollIntoView({ behavior: "smooth", block: "nearest" });
    };


    const handleBlur = useCallback((event) => {
            if (!event || !event.currentTarget) return;
        // Asegúrate de que no se cierra si haces clic en un elemento de la lista
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setFilteredpostalCodeAutDest([]);
            setHighlightedIndexPostalCodeAutDest(-1);
            setFilteredDocumentIdAutDest([]);
            setHighlightedIndexDocumentIdAutDest(-1);
            setFilteredTradenamedAutDest([]);
            setHighlightedIndexTradenamedAutDest(-1);  
            setFilteredAutDestNima([]);
            setHighlightedIndexAutDestNima(-1); 
        }
    }, []);

    const handleChangeSelectDocumentType_Dest_tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            aut_dest_documnettype_id:event.target.value
        }));
    };

    const handleBlurSelectDocumentType_Dest_tras = (e) => {
        handleChangeSelectDocumentType_Dest_tras(e);
    };
    
    const handleChangeSelectRoadType_Dest_tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            aut_dest_roadtype_id : event.target.value 
        }));
    };

    const handleBlurSelectRoadType_Dest_tras = (e) => {
        handleChangeSelectRoadType_Dest_tras(e);
        setErrorsForm(validateFormContract());
    };

    const handleChangeSelectCommunity_Dest_tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            aut_dest_community_id : event.target.value   
        }));
    };
    const handleBlurSelectCommunity_Dest_tras = (e) => {
        handleChangeSelectCommunity_Dest_tras(e);
        setErrorsForm(validateFormContract());
    };

    const handleChangeDataEditContract_Dest_tras = (e) => {
        const { name, value } = e.target;
        setFormContract(formContract => ({
          ...formContract,
          [name]: value,
        }));
    };

    const handleBlurDataEditContract_Dest_tras = (e) => {
        handleChangeDataEditContract_Dest_tras(e);
        setErrorsForm(validateFormContract());
    };
    
    const searchFormStore = (event) => {
        setShowModalSearchStores(true);
    };

    const searchFormStoreAddress = (event) => {
        setShowModalSearchStoresAddress(true);
    };

    const searchFormStoreNimaAddress = (event) => {
        setShowModalSearchStoresNimaAddress(true);
    };

    const deleteDateAutDest = (event) => {
        setFormContract(formContract => ({
          ...formContract,
           aut_dest_store_id:0,
            aut_dest_documnettype_id: Number(DEFAULTTYPEOFDOCUMENT),
            aut_dest_documentid:"",
            aut_dest_tradename: "",
            aut_dest_name: "",
            aut_dest_contactname: "",
            aut_dest_nima: "",
            aut_dest_inscription: "",
            aut_dest_grnp:"",
            aut_dest_opt: 0,
            aut_dest_phone: "",
            aut_dest_email: "",
            aut_dest_roadtype_id: Number(DEFAULTROADTYE),
            aut_dest_street: "",
            aut_dest_country_id: Number(DEFAULTCOUNTRY),
            aut_dest_country_name:DEFAULTCOUNTRY_NAME,
            aut_dest_province_id: Number(DEFAULTPROVINCE),
            aut_dest_province_name:DEFAULTPROVINCE_NAME,
            aut_dest_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            aut_dest_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            aut_dest_postalcode_name: DEFAULTPOSTALCODE_NAME,
            aut_dest_community_id: Number(DEFAULTCOMMUNITY),
            aut_dest_community_name: DEFAULTCOMMUNITY_NAME
        }));
        setErrorsForm(validateFormContract());
        setErrorsForm(errorsForm => ({
            ...errorsForm,
            aut_dest_store_id:"",
            aut_dest_documnettype_id:"",
            aut_dest_documentid:"",
            aut_dest_tradename: "",
            aut_dest_name: "",
            aut_dest_contactname: "",
            aut_dest_nima: "",
            aut_dest_inscription: "",
            aut_dest_grnp:"",
            aut_dest_opt: "",
            aut_dest_phone: "",
            aut_dest_email: "",
            aut_dest_roadtype_id: "",
            aut_dest_street: "",
            aut_dest_country_id: "",
            aut_dest_country_name: "",
            aut_dest_province_id: "",
            aut_dest_province_name: "",
            aut_dest_postalcode_id: "",
            aut_dest_postalcode_code: "",
            aut_dest_postalcode_name: "",
            aut_dest_community_id: "",
            aut_dest_community_name: ""
        }));
    };

    const deleteDataSteetAutDest = (event) => {
        setFormContract(formContract => ({
          ...formContract,
            aut_dest_roadtype_id: Number(DEFAULTROADTYE),
            aut_dest_street: "",
            aut_dest_country_id: Number(DEFAULTCOUNTRY),
            aut_dest_country_name:DEFAULTCOUNTRY_NAME,
            aut_dest_province_id: Number(DEFAULTPROVINCE),
            aut_dest_province_name:DEFAULTPROVINCE_NAME,
            aut_dest_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            aut_dest_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            aut_dest_postalcode_name: DEFAULTPOSTALCODE_NAME,
            aut_dest_community_id: Number(DEFAULTCOMMUNITY),
            aut_dest_community_name: DEFAULTCOMMUNITY_NAME, 
            aut_dest_nima: "",
            aut_dest_inscription: "",
            aut_dest_grnp:"",
            aut_dest_opt: 0
        }));
        setErrorsForm(validateFormContract());
    };
 
    useEffect(() => {
        let isMounted = true;
        const fetchExistNumberDocument = async () => {
            try {
              const getData = await helpHttp().get2(ENDPOINT,`contract/getexiststorebynumberdocument/`,token,formContract.aut_dest_documentid.replace(/[.\-/\\|]/g, "").trim());
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData>0 && getData!==formContract.aut_dest_store_id){
                    fetchStoreNumberDocument();
                }
              }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
 
        const fetchStoreNumberDocument = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`contract/getstorebynumberdocumentpriority`,token,formContract.aut_dest_documentid.replace(/[.\-/\\|]/g, "").trim(),5);
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    if (getData!==undefined && getData!==null && getData!==""){
                        setFormContract(formContract => ({
                            ...formContract,
                            aut_dest_store_id: getData.store_id,
                            aut_dest_documnettype_id: (getData.documnettype_id===undefined 
                                                    || getData.documnettype_id===null  
                                                    || getData.documnettype_id===""
                                                    || getData.documnettype_id==="0"
                                                    || getData.documnettype_id===0)?
                                                    Number(DEFAULTTYPEOFDOCUMENT):getData.documnettype_id,
                            aut_dest_tradename: getData.tradename,
                            aut_dest_name: getData.name,
                            aut_dest_contactname: getData.contacperson,
                            aut_dest_nima: getData.nima_aut_dest,
                            aut_dest_inscription: getData.pygr_aut_dest,
                            aut_dest_grnp:getData.grnp_aut_dest,
                            aut_dest_opt: getData.opt_aut_dest,
                            aut_dest_phone: getData.phone,
                            aut_dest_email: getData.email, 
                            aut_dest_roadtype_id: (getData.roadtype_id===undefined 
                                                    || getData.roadtype_id===null  
                                                    || getData.roadtype_id===""
                                                    || getData.roadtype_id==="0"
                                                    || getData.roadtype_id===0)?
                                                    Number(DEFAULTROADTYE):getData.roadtype_id,
                            aut_dest_street: getData.street,  
                            aut_dest_country_id: (getData.country_id===undefined 
                                                    || getData.country_id===null  
                                                    || getData.country_id===""
                                                    || getData.country_id==="0"
                                                    || getData.country_id===0)?
                                                    Number(DEFAULTCOUNTRY):getData.country_id,
                            aut_dest_country_name: (getData.country_name===undefined 
                                                    || getData.country_name===null  
                                                    || getData.country_name==="" )?
                                                    DEFAULTCOUNTRY_NAME:getData.country_name,
                            aut_dest_province_id: (getData.province_id===undefined 
                                                    || getData.province_id===null  
                                                    || getData.province_id===""
                                                    || getData.province_id==="0"
                                                    || getData.province_id===0)?
                                                    Number(DEFAULTPROVINCE):getData.province_id,
                            aut_dest_province_name: (getData.province_name===undefined 
                                                    || getData.province_name===null  
                                                    || getData.province_name==="" )?
                                                    DEFAULTPROVINCE_NAME:getData.province_name, 
                            aut_dest_postalcode_id: (getData.postalcode_id===undefined 
                                                        || getData.postalcode_id===null  
                                                        || getData.postalcode_id===""
                                                        || getData.postalcode_id==="0"
                                                        || getData.postalcode_id===0)?
                                                        Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id,
                            aut_dest_postalcode_code: (getData.postalcode_code===undefined 
                                                        || getData.postalcode_code===null  
                                                        || getData.postalcode_code==="" )?
                                                         DEFAULTPOSTALCODE_CODE:getData.postalcode_code,
                            aut_dest_postalcode_name:   (getData.postalcode_name===undefined 
                                                        || getData.postalcode_name===null  
                                                        || getData.postalcode_name==="" )?
                                                         DEFAULTPOSTALCODE_NAME:getData.postalcode_name,                       
                            aut_dest_community_id: (getData.community_id===undefined 
                                                        || getData.community_id===null  
                                                        || getData.community_id===""
                                                        || getData.community_id==="0"
                                                        || getData.community_id===0)?
                                                        Number(DEFAULTCOMMUNITY):getData.community_id,
                            aut_dest_community_name:   (getData.community_name===undefined 
                                                        || getData.community_name===null  
                                                        || getData.community_name==="" )?
                                                         DEFAULTCOMMUNITY_NAME:getData.community_name
                        }));
                        setErrorsForm(validateFormContract());
                    }  
                }         
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel5'){
            if (formContract.aut_dest_documentid && formContract.aut_dest_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
                fetchExistNumberDocument();
            } 
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,expanded,formContract.aut_dest_documentid,errorsForm.aut_dest_documentid,setIsLoadingErrorData,DEFAULTCOMMUNITY,DEFAULTCOUNTRY,setFormContract,formContract.aut_dest_store_id,DEFAULTPROVINCE,setErrorsForm,validateFormContract,
        DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTTYPEOFDOCUMENT
    ]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataDocumentIdAutDest = async () => {
          try {
            const getData = await helpHttp().get2(ENDPOINT,`contract/getlistdocumentidcontracts/`,token,
              (formContract.aut_dest_documentid!==undefined && formContract.aut_dest_documentid!==null && formContract.aut_dest_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.aut_dest_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
              setDocumentIdAutDestToSelect(getData); 
            }
          } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }
        };   
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel5'){
            if (formContract.aut_dest_documentid && formContract.aut_dest_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataDocumentIdAutDest();
            }
        } else{
            setDocumentIdAutDestToSelect(initialDocumentIdToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.aut_dest_documentid,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataTradenameAutDest = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlisttradenamecontracts/`,token,
                    (formContract.aut_dest_tradename!==undefined && formContract.aut_dest_tradename!==null && formContract.aut_dest_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.aut_dest_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setTradenameAutDestToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel5'){
            if (formContract.aut_dest_tradename && formContract.aut_dest_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataTradenameAutDest();
            }
        } else{
            setTradenameAutDestToSelect(initialDocumentIdToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.aut_dest_tradename,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeAutDest = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlistpostalcodect/`,token,
                    (formContract.aut_dest_postalcode_code!==undefined && formContract.aut_dest_postalcode_code!==null && formContract.aut_dest_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.aut_dest_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeAutDestToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel5'){
            if (formContract.aut_dest_postalcode_code && formContract.aut_dest_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeAutDest();
            } 
        } else{
            setPostalCodeAutDestToSelect(initialPostalCodesToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.aut_dest_postalcode_code,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormContract]);
    
     useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeAutDestFiscal = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlistpostalcodect/`,token,
                    (formContract.aut_dest_postalcode_code_fiscal!==undefined && formContract.aut_dest_postalcode_code_fiscal!==null && formContract.aut_dest_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.aut_dest_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeAutDestToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel5'){
            if (formContract.aut_dest_postalcode_code_fiscal && formContract.aut_dest_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeAutDestFiscal();
            } 
        } else{
            setPostalCodeAutDestToSelect(initialPostalCodesToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.aut_dest_postalcode_code_fiscal,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormContract]);

    useEffect(() => {
        let isMounted = true; 
        const fetchDataNimaAutDest = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`searchct/getlistnimas`,token,formContract.aut_dest_store_id, 
                    (formContract.aut_dest_nima!==undefined && formContract.aut_dest_nima!==null && formContract.aut_dest_nima.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.aut_dest_nima.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setAutDestNimaToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel5'){
            if (formContract.aut_dest_store_id && formContract.aut_dest_store_id!==null && formContract.aut_dest_store_id!=="" && formContract.aut_dest_store_id!=="0" && formContract.aut_dest_store_id!==0){
                fetchDataNimaAutDest(); 
            }else{
                setAutDestNimaToSelect(initialNimaToSelect);
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract,expanded,setFormContract,formContract.aut_dest_store_id]);
    
    return(
    (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel5') &&
        <>
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_DocuentType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="aut_dest_documnettype_id"
                        name="aut_dest_documnettype_id"
                        value={ (formContract.aut_dest_documnettype_id === undefined || formContract.aut_dest_documnettype_id ===null || formContract.aut_dest_documnettype_id ===""
                            || formContract.aut_dest_documnettype_id ==="0" || formContract.aut_dest_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formContract.aut_dest_documnettype_id}
                        inputProps={{ style: {width: 200,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectDocumentType_Dest_tras}
                        onChange={handleChangeSelectDocumentType_Dest_tras}
                        helperText={errorsForm.aut_dest_documnettype_id!=null && errorsForm.aut_dest_documnettype_id!==""?t(errorsForm.aut_dest_documnettype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.aut_dest_documnettype_id === undefined || formContract.aut_dest_documnettype_id ===null || formContract.aut_dest_documnettype_id ===""
                                || formContract.aut_dest_documnettype_id ==="0" || formContract.aut_dest_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formContract.aut_dest_documnettype_id
                        }}>
                        <option key={0} value=""/>
                        {documentTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.name}
                            </option>
                        ))}
                    </TextField>  
                    {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    <label className="text-primary" style={{ fontSize: 18}}>{t('Text_CONTRACT_CIF')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;  
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="aut_dest_documentid"
                            name="aut_dest_documentid"
                            value={formContract.aut_dest_documentid}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                ...prev,
                                aut_dest_documentid: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchDocumentId(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDocumentIdAutDest}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.aut_dest_documentid!=null?t(errorsForm.aut_dest_documentid):t('PlaceHolder_CONTRACT_CIF')}
                            placeholder={t('PlaceHolder_CONTRACT_CIF')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?283:323,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredDocumentIdAutDest.length > 0 && (
                            <div
                                ref={ddRefDocIdAutDest}
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "400px",
                                overflowY: "auto",
                                width: "250%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredDocumentIdAutDest.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectDocumentIdOri(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexDocumentIdAutDest ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexDocumentIdAutDest ? "white" : "black",
                                    }}
                                >
                                    {store.documentid} - {store.tradename}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>  
                    &nbsp;&nbsp;
                    <IconButton  size="small" className="deletesmall-select-button"   onClick={deleteDateAutDest}>
                        <DeleteIcon style={{fontSize: 28}}/>
                    </IconButton>
                    &nbsp;&nbsp;
                    {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                        <IconButton  size="small" className="edit-select-button" onClick={searchFormStore}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton> 
                    } 
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_TRADENAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="aut_dest_tradename"
                            name="aut_dest_tradename"
                            value={formContract.aut_dest_tradename}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                    ...prev,
                                    aut_dest_tradename: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchTradename(e.target.value);
                            }}
                            onKeyDown={handleKeyDownTradenameAutDest}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.aut_dest_tradename!=null && errorsForm.aut_dest_tradename!==""?t(errorsForm.aut_dest_tradename):t('PlaceHolder_CONTRACT_TRADENAME')}
                            placeholder={t('PlaceHolder_CONTRACT_TRADENAME')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?858:834,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredTradenamedAutDest.length > 0 && (
                            <div
                                ref={ddRefTradeAutDest}
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "800px",
                                overflowY: "auto",
                                width: "150%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredTradenamedAutDest.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectTradeNameAutDest(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexTradenamedAutDest ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexTradenamedAutDest ? "white" : "black",
                                    }}
                                >
                                    {store.tradename} - {store.documentid}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_NAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_dest_name" 
                        name="aut_dest_name"
                        value={formContract.aut_dest_name}
                        inputProps={{ style: {width: i18n.language==='es'?812:857,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.aut_dest_name!=null && errorsForm.aut_dest_name!==""?t(errorsForm.aut_dest_name):t('PlaceHolder_CONTRACT_NAME')}
                        placeholder={t('PlaceHolder_CONTRACT_NAME')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras} 
                    />
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_CONTACT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_dest_contactname" 
                        name="aut_dest_contactname"
                        value={formContract.aut_dest_contactname}
                        inputProps={{ style: {width: i18n.language==='es'?795:840,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.aut_dest_contactname!=null && errorsForm.aut_dest_contactname!==""?t(errorsForm.aut_dest_contactname):t('PlaceHolder_CONTRACT_CONTACT')}
                        placeholder={t('PlaceHolder_CONTRACT_CONTACT')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras} 
                    />
                </div>
            </div> 
            <Typography style={{color:"#067330", fontSize: 16}} >  
                {t('Text_CONTRACT_ADDRESS')}
            </Typography>
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_RoadType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_dest_roadtype"
                        name="aut_dest_roadtype"
                        value={ (formContract.aut_dest_roadtype_id === undefined || formContract.aut_dest_roadtype_id ===null || formContract.aut_dest_roadtype_id ===""
                            || formContract.aut_dest_roadtype_id ==="0" || formContract.aut_dest_roadtype_id ===0)?Number(DEFAULTROADTYE):formContract.aut_dest_roadtype_id}
                        inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectRoadType_Dest_tras}
                        onChange={handleChangeSelectRoadType_Dest_tras}
                        helperText={errorsForm.aut_dest_roadtype_id!=null && errorsForm.aut_dest_roadtype_id!==""?t(errorsForm.aut_dest_roadtype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.aut_dest_roadtype_id === undefined || formContract.aut_dest_roadtype_id ===null || formContract.aut_dest_roadtype_id ===""
                                || formContract.aut_dest_roadtype_id ==="0" || formContract.aut_dest_roadtype_id ===0)?Number(DEFAULTROADTYE): formContract.aut_dest_roadtype_id
                        }}>
                        <option key={0} value=""/>
                        {roadTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_ADDRESS')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_dest_street" 
                        name="aut_dest_street"
                        value={formContract.aut_dest_street}
                        inputProps={{ style: {width: i18n.language==='es'?449:462,  fontSize: '18px', }, maxLength: 250 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.aut_dest_street!=null && errorsForm.aut_dest_street!==""?t(errorsForm.aut_dest_street):t('PlaceHolder_CONTRACT_ADDRESS')}
                        placeholder={t('PlaceHolder_CONTRACT_ADDRESS')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras}
                    />
                </div>
                &nbsp;&nbsp;
                <IconButton  size="small" className="deletesmall-select-button" onClick={deleteDataSteetAutDest}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton>
                &nbsp;&nbsp;
                {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&& formContract.aut_dest_documentid!==undefined && formContract.aut_dest_documentid!=="") ?
                    <IconButton  size="small" className={`edit-${
                        (formContract.aut_dest_store_id===undefined
                        || formContract.aut_dest_store_id===""
                        || formContract.aut_dest_store_id==="0"
                        || formContract.aut_dest_store_id===0 )
                        ? "noselect-button": "select-button" }`}
                        disabled={formContract.aut_dest_store_id===undefined
                                || formContract.aut_dest_store_id===""
                                || formContract.aut_dest_store_id==="0"
                                || formContract.aut_dest_store_id===0 }
                                onClick={searchFormStoreAddress}>
                    <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>:
                    <IconButton  size="small" className="edit-noselect-button" disabled>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>
                } 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_PostalCode')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="aut_dest_postalcode_code"
                            name="aut_dest_postalcode_code"
                            value={formContract.aut_dest_postalcode_code}
                            onChange={(e) => {
                                    setFormContract(prev => ({
                                    ...prev,
                                    aut_dest_postalcode_code: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchPostalCode(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDPostalCodeAutDest}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    const inputPostalCode = formContract.aut_dest_postalcode_code.trim().toUpperCase();
                                    const matchedPostal = postalCodeAutDestToSelect.find((postal) => {
                                    const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                    return normalizedPostal === inputPostalCode;
                                    });

                                    if (matchedPostal) {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            aut_dest_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                            aut_dest_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                            aut_dest_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                            aut_dest_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE),
                                        }));
                                    } else {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            aut_dest_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                            aut_dest_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                            aut_dest_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                            aut_dest_province_id: Number(DEFAULTPROVINCE),
                                        }));
                                    }
                                    setFilteredpostalCodeAutDest([]);
                                    setHighlightedIndexPostalCodeAutDest(-1);
                                }
                            }}
                            label={errorsForm.aut_dest_postalcode_code!=null && errorsForm.aut_dest_postalcode_code!==""?t(errorsForm.aut_dest_postalcode_code):t('Text_CONTRACT_PostalCode')}
                            placeholder={t('Text_CONTRACT_PostalCode')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredpostalCodeAutDest.length > 0 && (
                            <div
                                ref={ddRefPostalAutDest}
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                width: "350%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredpostalCodeAutDest.map((postal, index) => (
                                <MenuItem
                                    key={postal.id}
                                    onClick={() => handleSelectPostalCodeAutDest(postal)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexPostalCodeAutDest ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexPostalCodeAutDest ? "white" : "black",
                                    }}
                                >
                                    {postal.postalcode} - {postal.name}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Locality')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_dest_postalcode_name" 
                        name="aut_dest_postalcode_name"
                        value={formContract.aut_dest_postalcode_name}
                        inputProps={{ style: {width: i18n.language==='es'?210:241,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.aut_dest_postalcode_name!=null && errorsForm.aut_dest_postalcode_name!==""?t(errorsForm.aut_dest_contactname):t('Text_CONTRACT_Locality')}
                        placeholder={t('Text_CONTRACT_Locality')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras}
                        disabled
                    />  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Community')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_dest_community_id"
                        name="aut_dest_community_id"
                        value={ (formContract.aut_dest_community_id === undefined || formContract.aut_dest_community_id ===null || formContract.aut_dest_community_id ===""
                            || formContract.aut_dest_community_id ==="0" || formContract.aut_dest_community_id ===0)?Number(DEFAULTCOMMUNITY):formContract.aut_dest_community_id}
                        inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectCommunity_Dest_tras}
                        onChange={handleChangeSelectCommunity_Dest_tras}
                        helperText={errorsForm.aut_dest_community_id!=null  && errorsForm.aut_dest_community_id!==""?t(errorsForm.aut_dest_community_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.aut_dest_community_id === undefined || formContract.aut_dest_community_id ===null || formContract.aut_dest_community_id ===""
                                || formContract.aut_dest_community_id ==="0" || formContract.aut_dest_community_id ===0)?Number(DEFAULTCOMMUNITY): formContract.aut_dest_community_id
                        }}>
                        {communityToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>
                </div>
            </div> 
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Phone')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="aut_dest_phone" 
                        name="aut_dest_phone"
                        value={formContract.aut_dest_phone}
                        inputProps={{ style: {width: 180,  fontSize: '18px', }, maxLength: 30 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}    
                        label={errorsForm.aut_dest_phone!=null && errorsForm.aut_dest_phone!==""?t(errorsForm.aut_dest_phone):t('PlaceHolder_CONTRACT_Phone')}
                        placeholder={t('PlaceHolder_CONTRACT_Phone')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Email')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="aut_dest_email" 
                        name="aut_dest_email"
                        value={formContract.aut_dest_email}
                        inputProps={{ style: {width: i18n.language==='es'?319:335 ,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}     
                        label={errorsForm.aut_dest_email!=null && errorsForm.aut_dest_email!==""?t(errorsForm.aut_dest_email):t('PlaceHolder_CONTRACT_Email')}
                        placeholder={t('PlaceHolder_CONTRACT_Email')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_NIMA')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="aut_dest_nima"
                            name="aut_dest_nima"
                            value={formContract.aut_dest_nima}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                ...prev,
                                aut_dest_nima: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchAutDestNima(e.target.value);
                            }}
                            onKeyDown={handleKeyDownAutDestNima}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.aut_dest_nima!=null && errorsForm.aut_dest_nima!==""?t(errorsForm.aut_dest_nima):t('PlaceHolder_CONTRACT_NIMA')}
                            placeholder={t('PlaceHolder_CONTRACT_NIMA')}
                            variant="standard"
                            inputProps={{ style: {width: 133,  fontSize: '18px'}, maxLength: 50 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredAutDestNima.length > 0 && (
                            <div
                                ref={ddRefNimaAutDest}
                                className="dropdown-class"
                                style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    maxWidth: "750px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredAutDestNima.map((nt, index) => (
                                <MenuItem
                                    key={nt.id}
                                    onClick={() => handleSelectAutDestNima(nt)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexAutDestNima ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexAutDestNima ? "white" : "black",
                                    }}
                                >
                                    {nt.nima}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                        &nbsp;&nbsp;
                    {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formContract.aut_dest_documentid!==undefined && formContract.aut_dest_documentid!=="") ?
                         <IconButton  size="small" className={`edit-${
                            (formContract.aut_dest_store_id===undefined
                            || formContract.aut_dest_store_id===""
                            || formContract.aut_dest_store_id==="0"
                            || formContract.aut_dest_store_id===0 
                            )? "noselect-button": "select-button" }`}
                            disabled={formContract.aut_dest_store_id===undefined
                                    || formContract.aut_dest_store_id===""
                                    || formContract.aut_dest_store_id==="0"
                                    || formContract.aut_dest_store_id===0 } 
                            onClick={searchFormStoreNimaAddress}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>:
                        <IconButton  size="small" className="edit-noselect-button" disabled>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton> 
                    }
                </div>
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_INSCRIPTION')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="aut_dest_inscription" 
                        name="aut_dest_inscription"
                        value={formContract.aut_dest_inscription}
                        inputProps={{ style: {width:350,  fontSize: '18px'}, maxLength: 50 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}      
                        label={errorsForm.aut_dest_inscription!=null && errorsForm.aut_dest_inscription!==""?t(errorsForm.aut_dest_inscription):t('PlaceHolder_CONTRACT_INSCRIPTION')}
                        placeholder={t('PlaceHolder_CONTRACT_INSCRIPTION')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras} 
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_OPT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;  
                    <TextField
                        id="aut_dest_opt"
                        name="aut_dest_opt"
                        value={ (formContract.aut_dest_opt === undefined || formContract.aut_dest_opt ===null || formContract.aut_dest_opt ===""
                            || formContract.aut_dest_opt ==="0" || formContract.aut_dest_opt ===0)?0:formContract.aut_dest_opt}
                        inputProps={{ style: {width: i18n.language==='es'?194:171,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}     
                        variant="outlined"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras} 
                        helperText={errorsForm.aut_dest_opt!=null?t(errorsForm.aut_dest_opt):""}
                            select
                        SelectProps={{
                            native: true,
                            value: (formContract.aut_dest_opt === undefined || formContract.aut_dest_opt ===null || formContract.aut_dest_opt ===""
                                || formContract.aut_dest_opt ==="0" || formContract.aut_dest_opt ===0)?0: formContract.aut_dest_opt
                        }}>
                        <option key={0} value=""/>
                        {optTypeToSelect.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.code} - {option.namees.substring(0,20)}
                        </option>
                        ))}
                    </TextField>            
                </div>
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_GESTOR')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="aut_dest_grnp" 
                        name="aut_dest_grnp"
                        value={formContract.aut_dest_grnp}
                        inputProps={{ style: {width: i18n.language==='es'?684:250, fontSize: '18px'}, maxLength: 50 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.aut_dest_grnp!=null && errorsForm.aut_dest_grnp!==""?t(errorsForm.aut_dest_grnp):t('PlaceHolder_CONTRACT_GESTOR')}
                        placeholder={t('PlaceHolder_CONTRACT_GESTOR')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras} 
                    />
                    
                </div>
            </div> 
            <ContractSearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores}
                selectStores={"Aut_Dest"}
                setFormContract={setFormContract}
            />
            <ContractSearchStoresAddresses
                showModalSearchStoresAddress={showModalSearchStoresAddress}
                setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
                selectStores={"Aut_Dest"}
                setFormContract={setFormContract}
                titleTable={formContract.aut_dest_tradename}
                store_id={formContract.aut_dest_store_id}
                priority={5}
            />
             <ContractSearchStoresNimaAddresses
                showModalSearchStoresNimaAddress={showModalSearchStoresNimaAddress}
                setShowModalSearchStoresNimaAddress={setShowModalSearchStoresNimaAddress}
                selectStores={"Aut_Dest"}
                setFormContract={setFormContract}
                titleTable={formContract.aut_dest_tradename}
                store_id={formContract.aut_dest_store_id} 
            />
        </> 
    )
}

ContractCreateOrEditAutDest.propTypes = {
    formContract: PropTypes.object.isRequired,
    setFormContract: PropTypes.func.isRequired,
    setIsLoadingErrorData: PropTypes.func.isRequired,
    errorsForm: PropTypes.object.isRequired,
    setErrorsForm: PropTypes.func.isRequired,
    validateFormContract: PropTypes.func.isRequired,
    documentTypesToSelect: PropTypes.array.isRequired,
    roadTypesToSelect: PropTypes.array.isRequired,
    communityToSelect: PropTypes.array.isRequired,
    optTypeToSelect: PropTypes.array.isRequired
  };
  
  export default ContractCreateOrEditAutDest;
